import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=359afec6&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=359afec6&prod&scoped=true&lang=css"
import style1 from "./Register.vue?vue&type=style&index=1&id=359afec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359afec6",
  null
  
)

export default component.exports